import styled from 'styled-components';

export const WeatherSectionSelectStyle = styled.div`
    .input-select {
        width: 160px;
    }
`;
